import React, {Component} from 'react';
import {Line} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getGradients, getDifference, getSum} from './budget_charts_util';

class ProfitChart extends Component {
	getChartData() {
		const {itemsOutsideProjectPeriod, isEstimatedInNewPoints, isFixedPrice} = this.props;
		const {formatMessage} = this.props.intl;
		const {costActualPerDay, costPlannedPerDay, costRemainingPerDay, pricePlannedPerDay, priceActualPerDay, priceRemainingPerDay, project, labels} = this.props.data;
		const {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual, gradientStrokeFixedPrice, gradientFillFixedPrice} = getGradients();

		const plannedProfitPerDay = getDifference(getChartDataByDay({project, dayData: pricePlannedPerDay}), getChartDataByDay({project, dayData: costPlannedPerDay}));
		const actualProfitPerDay = getDifference(getChartDataByDay({project, dayData: priceActualPerDay}), getChartDataByDay({project, dayData: costActualPerDay}));
		const remainingProfitPerDay = getDifference(getChartDataByDay({project, dayData: priceRemainingPerDay}), getChartDataByDay({project, dayData: costRemainingPerDay}));
		const actualProfit = getAccumulation(getChartDataByDay({project, dayData: actualProfitPerDay, projection: false}));

		const firstActualNullIndex = actualProfit.findIndex(number => number === null);
		let datasets = [];

		if (isFixedPrice) {
			const fixedPriceProfitPerDay = labels.map(() => project.budget);
			const costRemainingPerDayFormatted = getChartDataByDay({project, dayData: costRemainingPerDay});
			const costActualPerDayFormatted = getChartDataByDay({project, dayData: costActualPerDay});
			const result = [];

			for (let i = 0; i < labels.length; i++) {
				const prevValue = result[i - 1];
				let difference = (prevValue != null ? prevValue : fixedPriceProfitPerDay[i]) - (costRemainingPerDayFormatted[i] + costActualPerDayFormatted[i]);

				result.push(difference);
			}

			datasets.unshift({
				label: formatMessage({id: 'project_budget.fixed_price_profit'}),
				borderColor: gradientStrokeFixedPrice,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'transparent',
				pointHoverBorderColor: gradientStrokeFixedPrice,
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFillFixedPrice,
				borderWidth: 2,
				data: result,
			});
		} else {
			if (!isEstimatedInNewPoints) {
				datasets.push({
					label: formatMessage({id: 'project_budget.planned_profit'}),
					borderColor: gradientStroke,
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointBackgroundColor: 'rgba(217, 248, 232, 0.2)',
					pointHoverBorderColor: '#fff',
					pointRadius: 0,
					fill: true,
					backgroundColor: gradientFill,
					borderWidth: 2,
					data: getAccumulation(plannedProfitPerDay),
				});
			}
			const actualProfitData = getAccumulation(actualProfitPerDay);
			datasets.push({
				label: formatMessage({id: 'project_budget.actual_profit'}),
				borderColor: gradientStrokeActual,
				pointBackgroundColor: 'rgba(234, 248, 255, 0.8)',
				pointHoverBorderColor: '#fff',
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFillActual,
				borderWidth: 2,
				data: actualProfitData,
			});
		}

		if ((firstActualNullIndex !== -1 || isFixedPrice) && isEstimatedInNewPoints && !isFixedPrice) {
			let forecastProfit = null;
			if (isFixedPrice) {
				forecastProfit = getAccumulation(getSum(actualProfitPerDay, remainingProfitPerDay));
			} else {
				const actualProfitPerDayPast = getDifference(
					getChartDataByDay({project, dayData: priceActualPerDay.fill(null, firstActualNullIndex - 1, priceActualPerDay.length)}),
					getChartDataByDay({project, dayData: costActualPerDay.fill(null, firstActualNullIndex - 1, costActualPerDay.length)})
				);
				forecastProfit = getAccumulation(getSum(actualProfitPerDayPast, remainingProfitPerDay)).fill(null, 0, firstActualNullIndex - 1);
				forecastProfit[firstActualNullIndex - 1] = getAccumulation(actualProfitPerDayPast)[firstActualNullIndex - 1];
			}

			datasets.push({
				label: formatMessage({id: 'common.forecast'}),
				borderColor: gradientStrokeActual,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'transparent',
				pointHoverBorderColor: '#fff',
				pointRadius: 0,
				fill: true,
				backgroundColor: 'transparent',
				borderWidth: 2,
				data: forecastProfit,
				borderDash: [4, 2],
			});
		}

		if (itemsOutsideProjectPeriod) datasets.push(itemsOutsideProjectPeriod);

		return {
			datasets,
			labels,
		};
	}

	render() {
		return <Line data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(ProfitChart);
